module.exports = __webpack_public_path__ + "static/media/paso6-cambio.176fb219.png";